<main class="container">
    <h2>Download Companies</h2>
    <p>Please click below to download the completed file.</p>
    <a class="basic-button-base button-dark" style="width: 150px" [href]="openDownloadLink()" target="_blank" role="button">Download file</a>
</main>